import { ImageService } from './image.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.image', [])
  .service('imageService', ImageService).name;
